import CIMDashboardPage from './CIMDashboardPage';

export default CIMDashboardPage;
